/* ──────────────────────────────────────────────────────────────
   OVERLAY PLUMBING — additive only. The photo upload is the one
   remaining modal (the three questions are inline on the hero now), and
   it needs the three ways out every modal owes you: the close button,
   the backdrop, and Escape. Each performs exactly the same close the
   render path already performs, so there is only one definition of
   "closed".
   ────────────────────────────────────────────────────────────── */
(function(){

/* SHOPIFY PORT — same section root as the main script. This is a separate
   IIFE, so it needs its own handle and its own id lookup helper. The boot
   guard is deliberately NOT re-tested here: this block only wires overlays
   and measurements onto whichever wrapper it finds first, which is the same
   one the main script bound to. */
var BMVH_ROOT = document.querySelector('.bmvh') || document.documentElement;
var $ = function(id){ return BMVH_ROOT.querySelector('#' + id); };


  "use strict";
  var PANELS = [
    { wrap:'photoWrap',  tgl:'photoToggle',  form:'photoForm',
      close:'photoClose',  back:'photoBackdrop' }
  ];
  var shutters = [];

  PANELS.forEach(function(p){
    var wrap  = $(p.wrap);
    var tgl   = $(p.tgl);
    var form  = $(p.form);
    var close = $(p.close);
    var back  = $(p.back);
    if(!wrap || !tgl) return;

    function shut(returnFocus){
      if(!wrap.classList.contains('open')) return;
      wrap.classList.remove('open');
      tgl.setAttribute('aria-expanded', 'false');
      if(returnFocus){ try{ tgl.focus(); }catch(e){} }
    }
    shutters.push(shut);

    /* only one panel is ever up: opening either closes the other */
    tgl.addEventListener('click', function(){
      if(wrap.classList.contains('open')){
        shutters.forEach(function(fn){ if(fn !== shut) fn(false); });
      }
    });

    if(close) close.addEventListener('click', function(){ shut(true); });
    if(back)  back .addEventListener('click', function(){ shut(true); });

    /* Registered after the render listener, which flips data-state to
       "loading" synchronously once the input validates. So: it rendered,
       stand aside and let the hero show the plate. If validation failed the
       state is untouched and the panel stays up with its error. */
    if(form) form.addEventListener('submit', function(){
      if(BMVH_ROOT.getAttribute('data-state') === 'loading') shut(false);
    });
  });

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' || e.key === 'Esc'){
      shutters.forEach(function(fn){ fn(true); });
    }
  });

  /* The make-row wraps from one line to three between 1440 and 390, so its
     height is not a constant and cannot be a CSS token. Measure it and hand
     it to the hero as --barh; the sound pill and the prompt disclosure are
     pinned off that, so neither can ever land on top of the fields.

     IT IS THE BAR'S FIRST CONTENT, NOT THE BAR'S BOX. These were the same
     number until a heading was added above the fields; then the box grew by
     the heading's height and every control pinned off this line — the
     transport dock most visibly — was pushed up by it, which is the client's
     "bring the play buttons back down". Measuring to the top of the first
     thing actually IN the bar keeps the floor line where the content starts,
     so the dock no longer moves when that content changes height, and the
     heading sits inside the breathing gap above it rather than under the
     dock. Falls back to the box height whenever there is nothing to measure
     — during a render the heading is display:none and offsetParent is null,
     which is the same branch. */
  var hero = BMVH_ROOT.querySelector('.hero');
  var bar  = $('customForm');
  var copy = BMVH_ROOT.querySelector('.hero-copy');
  var dock = BMVH_ROOT.querySelector('.tvbar');
  if(hero && bar){
    var syncBar = function(){
      var floor = bar.offsetHeight;
      var first = $('makeNote');
      if(first && first.offsetParent){
        var bb = bar.getBoundingClientRect(), fb = first.getBoundingClientRect();
        if(fb.height) floor = bb.bottom - fb.top;
      }
      hero.style.setProperty('--barh', floor + 'px');
    };
    syncBar();
    if(window.ResizeObserver){ new ResizeObserver(syncBar).observe(bar); }
    else { window.addEventListener('resize', syncBar); }
    window.addEventListener('load', syncBar);
  }
  /* --copytop — see the comment on .scrim::after: .hero-copy's own OFFSET
     (not just its height) is what the wedge needs, and that offset moves
     whenever the viewport's height changes even if .hero-copy's own box
     never resizes, so this needs the resize/load listeners on top of a
     ResizeObserver — a ResizeObserver alone on .hero-copy itself would miss
     exactly that case. IT WOULD ALSO MISS THIS ONE: .hero-copy's own
     margin-top:auto is what actually positions it, and that margin is
     computed off the LIVE height of everything below it in the flex column
     — .tvbar included, even though .tvbar's own rule keeps it out of this
     var's name. .tvbar is display:none for the ~5s cold-load hold (see
     body.is-coldload) and pops back into flow the instant the first film
     cuts in, which shifts .hero-copy's offsetTop by .tvbar's own height
     without .hero-copy's own box changing size at all — confirmed with a
     live DOM probe (.hero-copy's own height held at 119.7px across the cut,
     only its top moved, by ~52px). A ResizeObserver on .hero-copy never
     sees that; one on .tvbar does, so both are watched. */
  if(hero && copy){
    var syncCopyTop = function(){
      hero.style.setProperty('--copytop', copy.offsetTop + 'px');
    };
    syncCopyTop();
    if(window.ResizeObserver){
      new ResizeObserver(syncCopyTop).observe(copy);
      if(dock){ new ResizeObserver(syncCopyTop).observe(dock); }
    }
    window.addEventListener('resize', syncCopyTop);
    window.addEventListener('load', syncCopyTop);
  }

  /* --owntop — glyph-accurate ink-top of the "O" in OWN. The client's ask
     ("pull the scrim down to 20px above OWN") needs the pixel that
     --copytop above cannot give: the real ink-top of the "O" glyph, not
     .hero-copy's box top (which carries padding) or a line box (which
     carries leading above the cap on top of that). Guessing a font's
     cap-height-to-line-height ratio by hand is exactly the kind of
     hardcoded number that breaks the moment the display font (BLACKMARKET,
     loaded font-display:swap — see the wrap comment near .makerow)
     finishes swapping in, or the vw-based clamp on .hero-title changes
     size across a resize. So this measures the real thing instead, off two
     browser primitives rather than an assumption:
       1. #capMark is a 0x0 inline-block, vertical-align:baseline, sitting
          immediately before the "O" — the layout engine's own rule for
          that combination puts its top/bottom edge exactly ON the line's
          real baseline, whatever font, size or leading is actually live.
       2. canvas's TextMetrics.actualBoundingBoxAscent gives the true
          rendered-ink distance from that same baseline up to the top of a
          glyph — not the font's nominal ascent (which overshoots a capital
          letter), the literal pixels. Rendering "O" in .hero-title's own
          computed font/weight/size gets the same ink extent .hero-title
          itself is painting.
     glyph ink-top (px, viewport) = baseline − ascent. On PHONE, --owntop is
     that figure converted to .hero's own coordinate space (.hero is the
     positioning context for .scrim, same as --copytop), so .scrim::after's
     mobile rule above can just do "− 20px" off it — a flat number, not
     another percentage or vh guess.

     CLIENT, LATER, DESKTOP: "the blurred box is too tall ... 20px on top of
     OWN". Same ink-top figure, extended to run above 760px too, but
     converted into .hero-copy's OWN coordinate space instead — that is
     what .hero-copy::before (the panel this fixes) is positioned against,
     not .hero. --owntop-panel is written onto .hero-copy for exactly that
     reason. Its horizontal twin, --ownright-panel, is the same idea turned
     sideways: canvas's actualBoundingBoxRight on "THE NIGHT" (the widest
     line, hardcoded here the same way 'O' is above — the copy is static
     markup, not data) gives the true ink-right distance from that line's
     own left edge, and .hero-title's own left edge in the viewport (no
     text-indent on this element, so the rendered line starts flush with
     it) is what anchors that measurement to a real pixel. ctx.letterSpacing
     is set for this one, unlike the single-glyph ascent read above, because
     letter-spacing measurably shifts where a multi-character line's ink
     actually ends; browsers without it simply ignore the assignment and
     the measurement falls back to canvas's own default (0) spacing.

     Runs on the same load/resize cadence as --copytop, plus a fonts.ready
     hook: BLACKMARKET swapping in changes the glyph's real ink metrics
     without necessarily changing #capMark's own box size, so the
     ResizeObserver on .hero-copy (which still fires for font-driven reflow
     of the block as a whole) is backed up by a direct listener on the
     font-load promise itself. */
  var title   = BMVH_ROOT.querySelector('.hero-title');
  var capMark = $('capMark');
  var heroTagEl = BMVH_ROOT.querySelector('.hero-tag');
  var ownScrim = window.matchMedia ? window.matchMedia('(max-width:760px)') : null;
  /* THE CLIENT'S PADDING, IN ONE PLACE. "make the padding 40px instead of
     20px on both sides" — top and right, the two edges this file measures to
     the glyph ink. Every consumer of that figure (the desktop wedge's
     --ownwide, and the copy panel's own top and right insets) reads it from
     here, so the number cannot drift between them the way it would if it were
     typed into three calc()s. The phone wedge keeps its own 20px: the client's
     screenshot and both instructions are the desktop panel, and a phone has
     nothing like the room to spend 40px on either side of the copy. */
  var OWN_PAD = 40;
  var copyScrim = BMVH_ROOT.querySelector('.copyscrim');
  if(hero && title && capMark && ownScrim){
    var ownCanvas = document.createElement('canvas');
    var ownCtx = ownCanvas.getContext('2d');
    /* the body copy (.hero-tag) wraps at a fixed 38ch, independent of the
       headline's own vw-based width — at some viewports its wrapped line
       actually renders WIDER than "THE NIGHT" (measured: 1024px wide, the
       tag's second line reached 6px past the headline's ink-right), which
       put part of the body copy outside a box sized purely off the
       headline and dropped it under the 4.5:1 floor. Real DOM line boxes
       (not a canvas re-measure — wrapping depends on layout, not a single
       font string) give the true rightmost edge actually on screen. */
    var tagMaxRight = function(){
      if(!heroTagEl || !heroTagEl.firstChild) return -Infinity;
      var r = document.createRange();
      r.selectNodeContents(heroTagEl);
      var rects = r.getClientRects();
      var max = -Infinity;
      for(var i = 0; i < rects.length; i++){ if(rects[i].right > max) max = rects[i].right; }
      return max;
    };
    /* THE BUTTON IS A CANDIDATE FOR "WIDEST", AND IT BECAME ONE.
       Above 1321px the relocation script moves .cta (the purple call to
       action) INTO this column, between the product line and the body copy —
       so it is one of the things the panel has to cover, exactly like the
       headline and the wrapped body copy already are. It was never measured
       because at "BUY NOW" it never won: measured at 1440px its right edge
       fell ~112px short of the headline's ink. The client's rename to "BUY AN
       EXPERIENCE" is more than twice as long and pushes it PAST the headline,
       so leaving it out would have sized the panel to the wrong element and
       hung the end of the button out over bare video.
       Its BORDER-BOX right edge is the figure, not glyph ink: unlike a run of
       text, the thing that must be covered here is the filled purple pill
       itself, and its padding and ring are part of what has to sit on tint.
       Returns -Infinity when the button is not in this column (every width
       below 1321px, where .cta lives under the transport dock instead), which
       drops it out of the Math.max without a special case. */
    /* THE PRODUCT LINE IS A WIDTH CANDIDATE TOO, AND IT BECAME ONE.
       It was safe to leave out while it read BLACK MARKET — 750ML: 20
       characters at 400 weight never won. ELEVATE EVERY EXPERIENCE is three
       characters longer AND bold, and its size clamp bottoms out at 10.5px
       while the headline's keeps scaling with the viewport — so at the narrow
       end of the tablet range (measured at 768px: product line ~202px against
       a "THE NIGHT" ink of ~150px) it renders WIDER than the headline it sits
       under. Sizing the panel off the headline there would have hung the end
       of this line out over bare video, which is the exact fault the body copy
       and the button were each added here to fix. Live DOM rects, like the
       body copy's, because this line can wrap. */
    var productMaxRight = function(){
      var el = BMVH_ROOT.querySelector('.hero-copy .hero-product');   /* the panel's line, not the make-row heading */
      if(!el || !el.firstChild) return -Infinity;
      var r = document.createRange();
      r.selectNodeContents(el);
      var rects = r.getClientRects();
      var max = -Infinity;
      for(var i = 0; i < rects.length; i++){ if(rects[i].right > max) max = rects[i].right; }
      return max;
    };
    /* ── THE INK BOTTOM OF THE LAST LINE OF BODY COPY ──────────────────────
       CLIENT: "move the bottom of the blur box to 40px under the last
       sentence." The panel's other two offsets are already measured to real
       glyph ink (the top to the ink-top of the "O", the right to the ink-right
       of the widest line), and this is the third one measured the same way, so
       all three mean the same thing.

       WHY NOT THE OBVIOUS THING. The paragraph's box bottom, and the line
       box's bottom, both sit BELOW the last line's ink by half the leading —
       at 13.5px/1.58 that is ~4px of nothing, and the copy block's own box is
       further out again (it carries the .hud row and the block's bottom
       padding, which is what put the old edge 57-65px down instead of 40).
       Measuring to either would put the visible edge somewhere other than the
       40px the client asked for.

       HOW THE INK IS FOUND. There is no API for "bottommost painted pixel of
       a line", so it is composed from two things the platform does give:
         · the last LINE BOX, from the range's own client rects — the last
           rect is the last line, and its top and height are exact;
         · the deepest ink this copy can put below a baseline, from canvas's
           actualBoundingBoxDescent measured over the paragraph's text.
       The baseline sits at that line box's top plus half the leading plus the
       font ascent — the standard half-leading model, using the FONT metrics
       (fontBoundingBox*) for the leading and the INK metric for the drop.

       THE DESCENT IS MEASURED OVER THE WHOLE PARAGRAPH, NOT THE LAST LINE
       ALONE, AND THAT IS DELIBERATE. Isolating the final line means walking
       the text node character by character looking for the first one whose
       rect joins the last line — which is fragile around soft wraps and
       collapsed whitespace (the source is indented across four physical
       lines, so the runs between words are not single spaces), and it was
       measurably picking up part of the line above. The paragraph's own
       descent is a SUPERSET of any one line's, so it can only ever place the
       edge at or below the true ink — it cannot clip a descender, which is
       the failure that would actually matter. For the copy as it stands the
       two are identical anyway: the last line ends "...natural energy boost
       that can last for hours", the "gy" in energy already reaches the font's
       full descender depth, and both readings measure 2.78px at 13.5px type.
       Whatever the figure, the edge is drawn 40px BELOW it.

       Returns null when the paragraph is not rendered (every phone), which
       drops the whole calculation back to the copy block's box — see the
       caller. */
    var tagInkBottom = function(){
      if(!heroTagEl || !heroTagEl.firstChild) return null;
      if(getComputedStyle(heroTagEl).display === 'none') return null;
      var text = (heroTagEl.textContent || '').replace(/\s+/g, ' ').trim();
      var rg = document.createRange();
      rg.selectNodeContents(heroTagEl);
      var rects = rg.getClientRects();
      if(!rects.length || !text.length) return null;
      var last = rects[rects.length - 1];
      if(!last.height) return null;
      var ts = getComputedStyle(heroTagEl);
      ownCtx.font = ts.fontStyle + ' ' + ts.fontWeight + ' ' + ts.fontSize + '/' + ts.lineHeight + ' ' + ts.fontFamily;
      if('letterSpacing' in ownCtx) ownCtx.letterSpacing = ts.letterSpacing;
      var m = ownCtx.measureText(text);
      if('letterSpacing' in ownCtx) ownCtx.letterSpacing = '0px';
      var fa = m.fontBoundingBoxAscent, fd = m.fontBoundingBoxDescent;
      if(!isFinite(fa) || !isFinite(fd)) return null;
      var baseline = last.top + (last.height - (fa + fd)) / 2 + fa;
      var drop = isFinite(m.actualBoundingBoxDescent) ? Math.max(m.actualBoundingBoxDescent, 0) : 0;
      return baseline + drop;
    };
    var ctaMaxRight = function(){
      if(!copy) return -Infinity;
      var cta = copy.querySelector('.cta');
      if(!cta) return -Infinity;
      var r = cta.getBoundingClientRect();
      if(!r.width || !r.height) return -Infinity;
      var max = -Infinity, kids = cta.children;
      for(var i = 0; i < kids.length; i++){
        var kr = kids[i].getBoundingClientRect();
        if(kr.width && kr.right > max) max = kr.right;
      }
      /* .cta is width:100% of the column in this position, so its OWN rect is
         the column, not the button — the children are what is actually drawn.
         Falling back to the row's rect would size the panel to the column and
         undo the client's "hug the copy" ask outright. */
      return max;
    };
    var syncOwnTop = function(){
      var baseline = capMark.getBoundingClientRect().top;
      var cs = getComputedStyle(title);
      ownCtx.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + cs.fontSize + '/' + cs.lineHeight + ' ' + cs.fontFamily;
      var ascent = ownCtx.measureText('O').actualBoundingBoxAscent;
      if(!isFinite(ascent)) return;   // no actualBoundingBoxAscent support — CSS falls back to --copytop
      var heroBox = hero.getBoundingClientRect();
      var inkTopY = baseline - ascent;
      /* --owntop is written at EVERY width now, not only under 761px. It used
         to be phone-only because only the phone wedge consumed it; the
         desktop wedge (see the DESKTOP/TABLET WEDGE block in the stylesheet)
         now needs the identical figure, and the value itself is unchanged —
         the ink-top of the "O" in .hero's own coordinate space, which is the
         positioning context .scrim sits in. */
      hero.style.setProperty('--owntop', (inkTopY - heroBox.top) + 'px');
      /* the ink-right of the widest line actually on screen. "THE NIGHT" is
         hardcoded the same way 'O' is above — the copy is static markup, not
         data — and ctx.letterSpacing is set for it, unlike the single-glyph
         ascent read, because tracking measurably moves where a multi-glyph
         line's ink ends. Browsers without the property ignore the assignment
         and fall back to canvas's own 0 spacing. */
      if('letterSpacing' in ownCtx) ownCtx.letterSpacing = cs.letterSpacing;
      /* WHICH LINE IS THE BOTTOM ONE DEPENDS ON THE VIEWPORT NOW.
         The headline is two lines up to 1200px and ONE line above it (the
         <br> is display:none there — see the DESKTOP: "OWN THE NIGHT" ON ONE
         LINE block in the stylesheet). Both end on the "T" of NIGHT and both
         start at the element's own left edge, so the only thing that changes
         is how much text precedes that T. Measuring 'THE NIGHT' on a
         one-line desktop would report the ink ending ~140px short of where it
         actually does and pull the panel's right edge in through the word
         OWN. The break's computed display is the honest signal — it is the
         same property the media query sets, so the two cannot disagree. */
      var titleBr = title.querySelector('br');
      var lastLine = (titleBr && getComputedStyle(titleBr).display === 'none')
                     ? 'OWN THE NIGHT' : 'THE NIGHT';
      var lineMetrics = ownCtx.measureText(lastLine);
      var inkRight = lineMetrics.actualBoundingBoxRight;
      /* the ink LEFT of the "O", for the panel's own left inset. Both the
         one-line and the two-line lockup begin on that same O at the same x,
         so one measurement serves both. actualBoundingBoxLeft is the distance
         the ink reaches to the LEFT of the text origin, so it subtracts. */
      var inkLeft = lineMetrics.actualBoundingBoxLeft;
      if('letterSpacing' in ownCtx) ownCtx.letterSpacing = '0px';
      if(!isFinite(inkRight)) return;
      if(!isFinite(inkLeft)) inkLeft = 0;
      /* the body copy wraps at a fixed 38ch, independent of the headline's
         own vw-based width, and at some viewports its wrapped line renders
         WIDER than "THE NIGHT" (measured: at 1024px the tag's second line
         reached 6px past the headline's ink-right). Whichever is genuinely
         farther right is what "20px right of the last letter" has to mean,
         or part of the body copy falls outside the box and under the 4.5:1
         floor. */
      var titleLeft = title.getBoundingClientRect().left;
      var headInkRightX = titleLeft + inkRight;
      var inkLeftX      = titleLeft - inkLeft;
      /* ── THE COLUMN IS CAPPED TO THE HEADLINE (desktop only) ──────────────
         The client's three paddings have to be the same distance from the
         same kind of thing — glyph ink — and the right one was being taken
         from the body copy, which had been widened to fill a column much
         wider than the headline. Handing the column the headline's own ink
         width makes the headline the widest thing in the block again, so the
         right edge lands 40px past the T of NIGHT exactly as the top lands
         40px above the O.
           --headink  the ink width from the column's text origin: what the
                      body copy is capped to, so it can never poke past the T.
           --copyw    that plus the column's own paddings, plus 6px, because
                      letter-spacing adds a trailing gap after the final T
                      that is part of the LINE's width but not of its ink —
                      without the slack the last word can tip onto a second
                      line. The slack widens the box, never the measured edge.
         Only written above 1200px; below that the headline is two lines and
         is far narrower than the copy, and capping to it would crush the
         paragraph into a ~25-character column. See the media query. */
      if(copy){
        var copyCs   = getComputedStyle(copy);
        var padL     = parseFloat(copyCs.paddingLeft)  || 0;
        var padR     = parseFloat(copyCs.paddingRight) || 0;
        var textLeft = copy.getBoundingClientRect().left + padL;
        var headInk  = headInkRightX - textLeft;
        if(headInk > 0){
          copy.style.setProperty('--headink', headInk + 'px');
          copy.style.setProperty('--copyw',  (headInk + padL + padR + 6) + 'px');
        }
      }
      var inkRightX = Math.max(headInkRightX,
                               tagMaxRight(), productMaxRight(), ctaMaxRight());
      /* --ownwide: how far the desktop wedge's left-to-right ramp is allowed
         to run before it must be fully transparent — that ink-right plus the
         client's padding, measured from .hero's own left edge. */
      hero.style.setProperty('--ownwide', (inkRightX - heroBox.left + OWN_PAD) + 'px');
      if(ownScrim.matches) return;
      /* DESKTOP/TABLET (>760px): the copy panel, .copyscrim. It is positioned
         in .hero's space (it is a sibling of .hero-copy, not a child — see the
         markup comment for why), so both figures are relative to .hero.
           top    OWN_PAD above the glyph ink. Exactly that, with nothing
                  added: the panel's edges are square now (the client asked
                  for the hard edge back), so the box edge and the tint edge
                  are the same line and the client's 40px is what gets
                  written. While the edges were feathered this had to carry
                  one fade-length of overhang on top, so the whole 40 landed
                  inside full-strength tint — there is no fade left to
                  overhang, and keeping the extra would have put the visible
                  edge 96px above the "O" instead of 40.
           bottom OWN_PAD below the ink of the last line of body copy — the
                  client's third 40px, measured the same way as the other two.
                  It was the copy block's own box bottom, which landed 57-65px
                  down because that box also contains the .hud row and the
                  block's bottom padding. Falls back to that same box bottom
                  when there is no body copy to measure against (phone, where
                  this panel is display:none anyway, and any browser without
                  the canvas ink metrics), so the edge is never left
                  unpositioned.
         Its width comes straight from --ownwide (already ink-right + OWN_PAD,
         set just above), in CSS — nothing to compute here. */
      if(!copyScrim || !copy) return;
      /* the left inset, the client's third matching side. Floored at 0: below
         about 1200px the gutter itself is narrower than the padding (36.7px
         at 834), so there is no room to inset by 40 and the panel keeps the
         full-bleed left it has always had there rather than hanging off the
         frame. */
      copyScrim.style.setProperty('--copyscrim-l',
                                  Math.max(0, inkLeftX - heroBox.left - OWN_PAD) + 'px');
      copyScrim.style.setProperty('--copyscrim-top',
                                  (inkTopY - heroBox.top - OWN_PAD) + 'px');
      var tagInkBot = tagInkBottom();
      var scrimBottomY = (tagInkBot === null)
                         ? copy.getBoundingClientRect().bottom
                         : tagInkBot + OWN_PAD;
      copyScrim.style.setProperty('--copyscrim-bot',
                                  (heroBox.bottom - scrimBottomY) + 'px');
      copyScrim.classList.add('is-measured');
    };
    syncOwnTop();
    if(window.ResizeObserver){
      new ResizeObserver(syncOwnTop).observe(copy);
      /* same cold-load→playing gap as --copytop above: .tvbar popping into
         flow moves the glyph without resizing .hero-copy itself, so it has
         to be watched directly too — see that comment for the measured
         proof. This is the one that matters most here: it is the exact
         "20px above OWN" figure the client is asking for, and it must hold
         once the first film is actually playing, not just at cold load. */
      if(dock){ new ResizeObserver(syncOwnTop).observe(dock); }
    }
    window.addEventListener('resize', syncOwnTop);
    window.addEventListener('load', syncOwnTop);
    if(ownScrim.addEventListener){ ownScrim.addEventListener('change', syncOwnTop); }
    if(document.fonts && document.fonts.ready){ document.fonts.ready.then(syncOwnTop); }
  }
})();
